import cloneDeep from 'lodash/cloneDeep';
import { isObject, isUndefined } from '@belong/type-utils';
import { AnalyticsEvents } from '../index';
import { buttonClick } from './commonEvents';

export const removeFromArray = <T>(arr: T[], itemToRemove: T): T[] => {
  return arr.filter(item => item !== itemToRemove);
};

export const combineAllObjects = <T>(...objects: T[]): T => {
  const base = {};
  Object.assign(base, ...objects);
  return base as T;
};

export const removeUndefinedFromObject = (object: object, deep = false): object => {
  // CloneDeep copies the functions' references, while structuredClone throws an error
  // when trying to clone an object with function attributes
  const cleanObject = cloneDeep(object);
  Object.keys(cleanObject).forEach(key => {
    if (isUndefined(cleanObject[key])) {
      delete cleanObject[key];
    } else if (deep && isObject(cleanObject[key])) {
      cleanObject[key] = removeUndefinedFromObject(cleanObject[key], deep);
    }
  });

  return cleanObject;
};

interface ITrackButtonClick {
  label: string;
  text: string;
  component?: string;
  analyticsEvents: AnalyticsEvents;
}

/**
 * @type {ITrackButtonClick}
 * Tracks button clicks
 * @param label
 * The value must communicate the intention of the element.
 * @param text
 * The exact button or link text from the element clicked
 * @param component
 * Optional name of the component the click originated from
 */
export const trackButtonClick = ({ label, text, component, analyticsEvents }: ITrackButtonClick): void => {
  analyticsEvents.send(
    buttonClick({
      label,
      text,
      component
    })
  );
};
